import { useState } from "react";
import { DATA, EmailSchema } from "shelving";
import { resetPassword } from "shared/firebase/auth";
import { Form, Icon, Page, SubmitButton, TextField } from "shared/react";

const resetSchema = DATA({
	email: new EmailSchema({ title: "Email address" }),
});

export function PasswordResetPage(): React.ReactElement {
	const [done, setDone] = useState<boolean>(false);
	return (
		<Page title="Password reset">
			<header>
				<img src="/img/icon.svg" className="icon size-5x" alt="Trajectory" title="Trajectory" />
				<h1>Password reset</h1>
			</header>
			<section>
				{done ? (
					<p className="notice notice-success">Password reset email sent</p>
				) : (
					<Form
						schema={resetSchema}
						onSubmit={async (values: { email: string }) => {
							await resetPassword(values);
							setDone(true);
						}}
					>
						<p>{"Enter the email address you used to register and we'll send a link to set a new password."}</p>
						<TextField name="email" />
						<SubmitButton children="Send reset email" />
					</Form>
				)}
			</section>
			<footer className="size-small flex-row gap-xsmall">
				<a href="/" className="button button-quiet">
					<Icon icon="left" /> <span>Login</span>
				</a>
			</footer>
		</Page>
	);
}
